import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsTokyometroComponent } from './simple-icons-tokyometro.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsTokyometroComponent ],
    exports:      [ SimpleIconsTokyometroComponent ],
    bootstrap:    []
})
export class SimpleIconsTokyometroModule {}
